import { TextButton } from '@creditornot/cb-button';
import { Trashbin } from '@creditornot/cb-icons';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import FileSelector from './FileSelector';
import ImagePreview from './ImagePreview';
import ImageWrapper from './ImageWrapper';
import { useObjectUrl } from './utils';

type Props = {
  className?: string;
  file: File;
  onImageChange: (file: File) => void;
  onRemove: () => void;
};

type State =
  | {
      type: 'initial';
    }
  | { type: 'selecting-file' };

const Actions = styled.div`
  display: flex;
  margin-block-start: 16px;
  & > * + * {
    margin-inline-start: 16px;
  }
`;

const NewImage = ({ className, file, onImageChange, onRemove }: Props) => {
  const [state, setState] = useState<State>({ type: 'initial' });

  const objectUrl = useObjectUrl(file);

  const renderState = () => {
    if (!objectUrl) {
      return null;
    }

    switch (state.type) {
      case 'initial': {
        return (
          <>
            <ImageWrapper>
              <ImagePreview imageUrl={objectUrl} />
            </ImageWrapper>
            <Actions>
              <TextButton
                onClick={() => {
                  setState({ type: 'selecting-file' });
                }}
              >
                <FormattedMessage id="image-upload.change-image" />
              </TextButton>
              <TextButton icon={<Trashbin />} onClick={onRemove} variant="red">
                <FormattedMessage id="image-upload.remove" />
              </TextButton>
            </Actions>
          </>
        );
      }
      case 'selecting-file': {
        return (
          <FileSelector
            background={<ImagePreview imageUrl={objectUrl} />}
            onCancel={() => {
              setState({ type: 'initial' });
            }}
            onSelectFile={file => {
              onImageChange(file);
              setState({ type: 'initial' });
            }}
          />
        );
      }
    }
  };

  return <div className={className}>{renderState()}</div>;
};

export default NewImage;
